//TODO : Refactor after ai
import type { InputHTMLAttributes, ReactNode } from "react";

export interface InputFieldProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "size" | "prefix"> {
  label?: string;
  required?: boolean;
  helper?: ReactNode;
  error?: ReactNode;
  size?: "md" | "sm";
  variant?: "outlined" | "filled";
  leadingIcon?: ReactNode;
  trailingIcon?: ReactNode;
  prefix?: ReactNode;
  suffix?: ReactNode;
}

/** Labelled text input: label + control + helper text, with addon slots. */
export function InputField({
  label,
  required,
  helper,
  error,
  size = "md",
  variant = "outlined",
  leadingIcon,
  trailingIcon,
  prefix,
  suffix,
  disabled,
  className = "",
  id,
  ...rest
}: InputFieldProps) {
  const inputId =
    id ?? (label ? `bui-${label.replace(/\W+/g, "-").toLowerCase()}` : undefined);

  return (
    <div className={`bui-field ${className}`}>
      {label && (
        <label className="bui-label" htmlFor={inputId}>
          {label}
          {required && <span className="bui-label__req">*</span>}
        </label>
      )}
      <div
        className="bui-input"
        data-size={size}
        data-style={variant === "filled" ? "filled" : undefined}
        data-error={Boolean(error) || undefined}
        data-disabled={disabled || undefined}
      >
        {prefix && (
          <span className="bui-input__addon" style={{ color: "var(--text-tertiary)" }}>
            {prefix}
          </span>
        )}
        {leadingIcon && <span className="bui-input__addon">{leadingIcon}</span>}
        <input id={inputId} disabled={disabled} {...rest} />
        {trailingIcon && <span className="bui-input__addon">{trailingIcon}</span>}
        {suffix && (
          <span className="bui-input__addon" style={{ color: "var(--text-tertiary)" }}>
            {suffix}
          </span>
        )}
      </div>
      {(error || helper) && (
        <span className="bui-help" data-state={error ? "error" : undefined}>
          {error ?? helper}
        </span>
      )}
    </div>
  );
}
